import { render, staticRenderFns } from "./SideNavFooter.vue?vue&type=template&id=16776617&scoped=true&"
import script from "./SideNavFooter.vue?vue&type=script&lang=js&"
export * from "./SideNavFooter.vue?vue&type=script&lang=js&"
import style0 from "./SideNavFooter.vue?vue&type=style&index=0&id=16776617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16776617",
  null
  
)

component.options.__file = "SideNavFooter.vue"
export default component.exports